import React, { PureComponent } from 'react'
import { Alert, Button, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchUsersTx, fetchUserTxById, USER_TX_ID_FAILURE } from '../actions'
import { disableBusinessFilter, enableBusinessFilter } from '../actions/business_filter'
import { disableCountryFilter, enableCountryFilter } from '../actions/country_filter'
import { resetCSVExport } from '../actions/csv_export'
import { disableStatusFilter, enableStatusFilter } from '../actions/status_filter'
import { doTxSearch, resetTxSearch, termValidationErrorHide } from '../actions/transaction_search'
import {
  disableTransactionSort,
  enableTransactionSort,
  TX_GRID_SORT_ACCESS_CODE,
  TX_GRID_SORT_ACCREDITED_INVESTOR,
  TX_GRID_SORT_COUNTRY_CODE,
  TX_GRID_SORT_CREATED,
  TX_GRID_SORT_FIRST_NAME,
  TX_GRID_SORT_LAST_NAME,
  TX_GRID_SORT_ORDER_ASC,
  TX_GRID_SORT_ORDER_DESC,
  TX_GRID_SORT_STATUS,
  TX_GRID_SORT_UPDATED,
} from '../actions/tx_grid_sort'
import BusinessFilterRedux from '../components/transaction_grid/business_filter_redux'
import { APP_USER, DATE_FORMAT, STORAGE_TYPE_LOCAL } from '../config'
import CSVExporterFactory from '../managers/csv_export/csv_exporter_factory'
import StorageProviderFactory from '../managers/storage_provider_factory'
import SortData from '../models/sort_data'
import { formatTimeString } from '../utils/formatters'
import {
  addToSearch,
  getSearchParams,
  getStatusFilter,
  isNewWindow,
  isStaff,
  isStaffOrClientReviewer,
} from '../utils/helpers'
import BooleanBadge from './boolean_badge'
import { CustomPagination } from './common/custom_pagination/custom_pagination'
import { DatePicker } from './common/datepicker'
import PageSizeFilter from './common/page_size_filter'
import { DivContentBox, DivTitleBox } from './common/styled'
import CSVExport from './csv_export'
import SimpleModal from './simple_modal'
import Spinner3Bounce from './spinner_3_bounce'
import StatusLabel from './status_label'
import CountryFilter from './transaction_grid/country_filter'
import SearchBar, { searchBarOptions } from './transaction_grid/search_bar'
import StatusFilterRedux from './transaction_grid/status_filter_redux'

class TxTable extends PureComponent {
  static csvExportHeader = [
    'Access Code',
    'First Name',
    'Last Name',
    'Country Code',
    'Created',
    'Updated',
    'Status',
    'Is Accredited Investor',
    'Investor Status',
  ]

  constructor(props) {
    super(props)
    const params = getSearchParams()

    const pageSize = StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem('pageSize')
      ? parseInt(StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem('pageSize'), 10)
      : 20

    let search
    const searchParameterArray = Object.keys(params).filter((value) =>
      searchBarOptions.map((i) => i.name).includes(value)
    )

    if (searchParameterArray.length) {
      const searchParameter = searchParameterArray[0]
      search = {
        searchTerm: params[searchParameter],
        searchParameter,
      }
      this.props.doTxSearch(params[searchParameter], searchParameter)
    }
    this.state = {
      activePage: this.getActivePage(),
      filter: params,
      createdOn: params['created_on'],
      pageSize: params['page_size'] ? params['page_size'] : pageSize,
      search,
      error: null,
    }
    this.handleSelectPage = this.handleSelectPage.bind(this)
    if (params.country) {
      this.props.enableCountryFilter(params.country)
    }
    if (params.business) {
      this.props.enableBusinessFilter(params.business)
    }

    if (params.filter) {
      // if (params.search) {
      //   this.props.doTxSearch(params.search)
      // }
      this.props.enableStatusFilter(getStatusFilter(params.filter))
    }
  }

  getActivePage() {
    const { location } = this.props
    if (location.search.indexOf('page=') !== -1) {
      return parseInt(location.search.split('page=').pop(), 0)
    }
    return 1
  }

  componentWillUnmount() {
    const { resetCSVExport } = this.props
    resetCSVExport()
  }

  componentDidMount() {
    const { state, props } = this
    const { filter, business, country } = state.filter
    const { fetchUsersTx, sortField, sortOrder } = props
    fetchUsersTx(
      this.getActivePage(),
      filter ? getStatusFilter(filter) : undefined,
      state.search,
      new SortData(sortField, sortOrder),
      business,
      country,
      state.pageSize,
      state.createdOn
    ).then(({ response }) => {
      if (response) {
        this.setState({
          totalCount: response.count,
        })
      }
    })

    const params = getSearchParams()

    const searchParameterArray = Object.keys(params).filter((value) =>
      searchBarOptions.map((i) => i.name).includes(value)
    )
    if (!searchParameterArray.length) {
      props.doTxSearch('', 'client_guid')
    }
  }

  handleSelectPage(page, metaKey) {
    const { state, props } = this
    const {
      statusFilter,
      businessFilter,
      searchTerm,
      searchParameter,
      sortField,
      sortOrder,
      fetchUsersTx,
      navigateToPage,
      navigateToPageInNewWindow,
      resetCSVExport,
      countryFilter,
    } = props
    if (page === this.getActivePage()) {
      return
    }
    resetCSVExport()
    let search = '?page=' + page
    if (countryFilter) {
      search = addToSearch(search, `country=${countryFilter}`)
    }
    if (searchTerm) {
      search = addToSearch(search, `${searchParameter}=${searchTerm}`)
    }
    if (businessFilter) {
      search = addToSearch(search, `business=${businessFilter}`)
    }
    if (statusFilter) {
      search = addToSearch(search, `filter=${statusFilter.map((f) => f[0])}`)
    }
    if (state.createdOn) {
      search = addToSearch(search, `created_on=${state.createdOn}`)
    }
    if (state.pageSize) {
      search = addToSearch(search, `page_size=${state.pageSize}`)
    }
    if (metaKey) {
      navigateToPageInNewWindow('', search || '')
    } else {
      navigateToPage('', search || '')
      fetchUsersTx(
        page,
        statusFilter,
        { searchTerm, searchParameter },
        new SortData(sortField, sortOrder),
        businessFilter,
        countryFilter,
        state.pageSize,
        state.createdOn
      )
    }
  }

  handleTableSort(field) {
    const { props, state } = this
    const {
      statusFilter,
      searchTerm,
      searchParameter,
      sortField,
      sortOrder,
      enableTransactionSort,
      disableTransactionSort,
      fetchUsersTx,
      resetCSVExport,
      businessFilter,
    } = props
    const page = this.getActivePage()
    resetCSVExport()

    let sortDirection = TX_GRID_SORT_ORDER_ASC
    if (sortField && sortField === field) {
      switch (sortOrder) {
        case TX_GRID_SORT_ORDER_ASC:
          sortDirection = TX_GRID_SORT_ORDER_DESC
          break
        case TX_GRID_SORT_ORDER_DESC:
          sortDirection = null
          break
        default:
      }
    }
    if (sortDirection) {
      enableTransactionSort(field, sortDirection)
    } else {
      disableTransactionSort()
      field = null
    }
    const sortData = new SortData(field, sortDirection)
    fetchUsersTx(
      page,
      statusFilter,
      { searchTerm, searchParameter },
      sortData,
      businessFilter,
      null,
      state.pageSize,
      state.createdOn
    )
  }

  viewTxDetails = (id, index, metaKey) => {
    const user = JSON.parse(StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem(APP_USER))

    // TODO remove this eventually - this is a stop gap for people who refresh this page before they reauthenticate.
    if (!user) {
      this.props.viewTxDetails(id, index, metaKey)
    }
    const review = this.props.userTxs.find((tx) => tx.id === id).state === 'post_processing'
    if (!isStaff(user) && review) {
      this.setState({ isOpen: true })
      return
    }

    this.props.viewTxDetails(id, index, metaKey)
  }

  getSortIcon = (field) => {
    const { sortOrder, sortField } = this.props
    let icon = null
    if (sortField && sortField === field) {
      switch (sortOrder) {
        case TX_GRID_SORT_ORDER_ASC:
          icon = <i className='fa fa-sort-amount-asc' />
          break
        case TX_GRID_SORT_ORDER_DESC:
          icon = <i className='fa fa-sort-amount-desc' />
          break
        default:
      }
      if (icon) {
        icon = <div style={{ float: 'right' }}>{icon}</div>
      }
    }
    return icon
  }

  updateCountryFilter = (country) => {
    this.props.enableCountryFilter(country)
    window.requestAnimationFrame(() => {
      this.updateAllFilters()
    })
  }

  updateBusinessFilter = (businessId) => {
    if (businessId === 0) {
      this.props.disableBusinessFilter()
    } else {
      this.props.enableBusinessFilter(businessId)
    }
    window.requestAnimationFrame(() => {
      this.updateAllFilters()
    })
  }

  updateSearchFilter = async ({ searchParameter, searchTerm }) => {
    if (searchParameter === 'txid') {
      try {
        const { error, type } = await this.props.fetchUserTxById(searchTerm)
        if (error && type === USER_TX_ID_FAILURE) {
          this.setState({ error })
        } else {
          this.props.viewTxDetails(searchTerm, 0)
        }
      } catch (e) {}
    } else {
      window.requestAnimationFrame(() => {
        this.updateAllFilters()
      })
    }
  }

  updatePageSizeFilter = ({ pageSize }) =>
    this.setState({ pageSize: parseInt(pageSize, 10) }, () => {
      window.requestAnimationFrame(() => this.updateAllFilters())
      StorageProviderFactory.create(STORAGE_TYPE_LOCAL).setItem('pageSize', pageSize)
    })

  updateStatusFilter = () => {
    let { statusFilter, disableStatusFilter } = this.props
    if (!statusFilter) {
      statusFilter = []
    }
    if (statusFilter.length === 0) {
      disableStatusFilter()
    } else {
      enableStatusFilter(statusFilter)
    }
    window.requestAnimationFrame(() => {
      this.updateAllFilters()
    })
  }

  updateDateFilter = (createdOn) => {
    this.setState({ createdOn }, () => window.requestAnimationFrame(() => this.updateAllFilters()))
  }

  updateAllFilters = () => {
    this.setState({ error: null })
    const { props, state } = this
    const { createdOn, pageSize } = state
    const {
      fetchUsersTx,
      navigateToPage,
      statusFilter,
      resetCSVExport,
      countryFilter,
      sortField,
      sortOrder,
      businessFilter,
      searchTerm,
      searchParameter,
    } = props

    resetCSVExport()

    let search = '?page=' + 1
    if (countryFilter) {
      search = addToSearch(search, `country=${countryFilter}`)
    }
    if (searchTerm) {
      search = addToSearch(search, `${searchParameter}=${searchTerm}`)
    }
    if (businessFilter) {
      search = addToSearch(search, `business=${businessFilter}`)
    }
    if (statusFilter) {
      search = addToSearch(search, `filter=${statusFilter.map((f) => f[0])}`)
    }
    if (createdOn) {
      search = addToSearch(search, `created_on=${createdOn}`)
    }
    if (pageSize) {
      search = addToSearch(search, `page_size=${pageSize}`)
    }
    navigateToPage('', search || '')
    fetchUsersTx(
      1,
      statusFilter,
      { searchTerm, searchParameter },
      new SortData(sortField, sortOrder),
      businessFilter,
      countryFilter,
      state.pageSize,
      state.createdOn
    )
  }

  resetAllFilters = () => {
    const { props, state } = this
    const {
      disableStatusFilter,
      resetTxSearch,
      disableBusinessFilter,
      navigateToPage,
      sortField,
      sortOrder,
      fetchUsersTx,
      disableCountryFilter,
    } = props
    disableStatusFilter()
    resetTxSearch()
    disableBusinessFilter()
    disableCountryFilter()
    this.setState({ createdOn: null })
    fetchUsersTx(1, null, null, new SortData(sortField, sortOrder), null, null, state.pageSize)
    navigateToPage('', '')
  }

  closeModalDialog = () => this.setState({ isOpen: false })

  render() {
    const { state, props } = this
    const { userTxs, errorMessage, count, requestUrl, countryFilter } = props
    const activePage = this.getActivePage()
    const user = JSON.parse(StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem(APP_USER))

    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <DivTitleBox className='ibox-title'>
          {isStaff(user) ? (
            <div className='row'>
              <div className='col-4'>
                <SearchBar updateSearchFilter={this.updateSearchFilter} />
              </div>
              <div className='col-2'>
                <BusinessFilterRedux updateBusinessFilter={this.updateBusinessFilter} />
              </div>
              <div className='col-2'>
                <CountryFilter updateFilter={this.updateCountryFilter} filter={countryFilter} />
              </div>
              <div className='col-2'>
                <PageSizeFilter updateFilter={this.updatePageSizeFilter} filter={state.pageSize} />
              </div>
              <div className='col-2'>
                <div className='input-group justify-content-between'>
                  <StatusFilterRedux updateFilter={this.updateStatusFilter} />
                  <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>Reset all filters</Tooltip>}>
                    <Button
                      style={{ backgroundColor: '#fff', float: 'right' }}
                      className='btn btn-md btn-white'
                      onClick={this.resetAllFilters}
                    >
                      <i className='fa fa-close' />
                    </Button>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          ) : (
            <div className='row'>
              <div className='col-xs-6 col-sm-5'>
                <SearchBar updateSearchFilter={this.updateSearchFilter} />
              </div>
              <div className='col-xs-6 col-sm-3'>
                <CountryFilter updateFilter={this.updateCountryFilter} filter={countryFilter} />
              </div>
              <div className='col-xs-6 col-sm-4'>
                <div className='input-group justify-content-between'>
                  <StatusFilterRedux updateFilter={this.updateStatusFilter} />
                  <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>Reset all filters</Tooltip>}>
                    <Button
                      style={{ backgroundColor: '#fff', float: 'right' }}
                      className='btn btn-md btn-white'
                      onClick={this.resetAllFilters}
                    >
                      <i className='fa fa-close' />
                    </Button>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          )}
          <div className='row mt-2'>
            <div className='col-xs-6 col-sm-5'>
              <DatePicker
                validation={false}
                value={this.state.createdOn}
                onChange={this.updateDateFilter}
                max={new Date().getFullYear()}
                min={new Date().getFullYear() - 20}
              />
            </div>
            <div className='col-xs-6 col-sm-5' />
            <div className='col-xs-6 col-sm-2 text-end'>
              <CSVExport
                exporter={CSVExporterFactory.USER}
                header={TxTable.csvExportHeader}
                count={count}
                url={requestUrl}
                totalCount={state.totalCount}
              />
            </div>
          </div>
        </DivTitleBox>
        <DivContentBox className='ibox-content'>
          <div>
            {errorMessage && <Alert bsStyle='danger'>{errorMessage}</Alert>}
            {this.state.error && <Alert bsStyle='danger'>{this.state.error}</Alert>}
            {userTxs === null ? (
              <>
                <div className='text-center grid-spinner-mt-240'>
                  <Spinner3Bounce isActive />
                </div>
              </>
            ) : (
              <>
                <div className='table-responsive'>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th
                          className='cursor-pointer td-nowrap'
                          onClick={() => this.handleTableSort(TX_GRID_SORT_ACCESS_CODE)}
                        >
                          <div style={{ width: '100px' }}>
                            <div style={{ float: 'left' }}>Access Code</div>
                            {this.getSortIcon(TX_GRID_SORT_ACCESS_CODE)}
                          </div>
                        </th>
                        <th
                          className='cursor-pointer td-nowrap'
                          onClick={() => this.handleTableSort(TX_GRID_SORT_FIRST_NAME)}
                        >
                          <div style={{ width: '90px' }}>
                            <div style={{ float: 'left' }}>First Name</div>
                            {this.getSortIcon(TX_GRID_SORT_FIRST_NAME)}
                          </div>
                        </th>
                        <th
                          className='cursor-pointer td-nowrap'
                          onClick={() => this.handleTableSort(TX_GRID_SORT_LAST_NAME)}
                        >
                          <div style={{ width: '90px' }}>
                            <div style={{ float: 'left' }}>Last Name</div>
                            {this.getSortIcon(TX_GRID_SORT_LAST_NAME)}
                          </div>
                        </th>
                        <th
                          className='cursor-pointer td-nowrap'
                          onClick={() => this.handleTableSort(TX_GRID_SORT_COUNTRY_CODE)}
                        >
                          <div style={{ width: '110px' }}>
                            <div style={{ float: 'left' }}>Country Code</div>
                            {this.getSortIcon(TX_GRID_SORT_COUNTRY_CODE)}
                          </div>
                        </th>
                        <th
                          className='cursor-pointer td-nowrap'
                          onClick={() => this.handleTableSort(TX_GRID_SORT_CREATED)}
                        >
                          Created {this.getSortIcon(TX_GRID_SORT_CREATED)}
                        </th>
                        <th
                          className='cursor-pointer td-nowrap'
                          onClick={() => this.handleTableSort(TX_GRID_SORT_UPDATED)}
                        >
                          Updated {this.getSortIcon(TX_GRID_SORT_UPDATED)}
                        </th>
                        <th
                          className='cursor-pointer td-nowrap'
                          onClick={() => this.handleTableSort(TX_GRID_SORT_STATUS)}
                        >
                          <div style={{ width: '125px' }}>
                            <div style={{ float: 'left' }}>KYC/AML Status</div>
                            {this.getSortIcon(TX_GRID_SORT_STATUS)}
                          </div>
                        </th>
                        <th
                          className='cursor-pointer td-nowrap'
                          onClick={() => this.handleTableSort(TX_GRID_SORT_ACCREDITED_INVESTOR)}
                        >
                          <div style={{ width: '150px' }}>
                            <div style={{ float: 'left' }}>Accredited Investor?</div>
                            {this.getSortIcon(TX_GRID_SORT_ACCREDITED_INVESTOR)}
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.userTxs.map((tx, index) =>
                        tx.transaction_identity ? (
                          <tr
                            key={tx.id}
                            className={!isStaffOrClientReviewer(user, tx.state) ? 'cursor-default' : 'cursor-pointer'}
                            title={'View Transaction ID: ' + tx.id}
                            onClick={(event) => this.viewTxDetails(tx.id, index, isNewWindow(event))}
                          >
                            <td>{tx.transaction_identity.client_guid}</td>
                            <td>{tx.transaction_identity.first_name}</td>
                            <td>{tx.transaction_identity.last_name}</td>
                            <td>{tx.transaction_identity.country_code}</td>
                            <td>{formatTimeString(tx.created, DATE_FORMAT)}</td>
                            <td>{formatTimeString(tx.updated, DATE_FORMAT)}</td>
                            <td>
                              <StatusLabel state={tx.state} holdReason={tx.hold_reason} />
                            </td>
                            <td>
                              <BooleanBadge
                                isTrue={tx.transaction_identity.is_accredited_investor}
                                accreditedDocumentStatus={tx.transaction_identity.accredited_document_status}
                              />
                            </td>
                          </tr>
                        ) : (
                          <tr key={tx.id}>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>{tx.created ? formatTimeString(tx.created) : '-'}</td>
                            <td>{tx.updated ? formatTimeString(tx.updated) : '-'}</td>
                            <td>{tx.state ? <StatusLabel state={tx.state} holdReason={tx.hold_reason} /> : '-'}</td>
                            <td>-</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                </div>
                <div className='text-center'>
                  <CustomPagination
                    activePage={activePage}
                    onPageChanged={this.handleSelectPage}
                    totalRecords={props.count}
                    pageLimit={state.pageSize}
                  />
                </div>
              </>
            )}
          </div>
        </DivContentBox>
        <SimpleModal
          isModalDialogOpen={state.isOpen}
          content={'This record is under review. You do not have permission to edit it.'}
          title='Information'
          close={this.closeModalDialog}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  errorMessage: state.tx.errorMessage,
  userTxs: state.tx.userTxs,
  isFetching: state.tx.isFetching,
  count: state.tx.count,
  nextUrl: state.tx.nextUrl,
  requestUrl: state.tx.requestUrl,
  businessFilter: state.businessFilter.businessFilter,
  countryFilter: state.countryFilter.countryFilter,
  statusFilter: state.statusFilter.statusFilter,
  searchTerm: state.transactionSearch.searchTerm,
  searchParameter: state.transactionSearch.searchParameter,
  pageHash: ownProps.location.hash,
  sortField: state.txGridSort.sortField,
  sortOrder: state.txGridSort.order,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      fetchUsersTx,
      enableTransactionSort,
      disableTransactionSort,
      resetCSVExport,
      enableCountryFilter,
      termValidationErrorHide,
      disableCountryFilter,
      enableBusinessFilter,
      disableBusinessFilter,
      enableStatusFilter,
      disableStatusFilter,
      viewTxDetails: (id, index, metaKey) => {
        const params = getSearchParams()
        const url = `/tx-details/${id}/${checkAndReplaceIndex(index, params)}${addIndex(index, params)}`
        if (metaKey) {
          window.open(url, '_blank')
          return false
        } else {
          return ownProps.history.push(url)
        }
      },
      viewTxVisualization: () => ownProps.history.push('/tx-visualization'),
      viewLandingPage: () => ownProps.history.push('/landing-page'),
      navigateToPage: (p, s) => ownProps.history.push({ pathname: '/', search: s || '' }),
      navigateToPageInNewWindow: (p, s) => {
        window.open(`/${s}`, '_blank')
      },
      doTxSearch,
      resetTxSearch,
      fetchUserTxById,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TxTable))

function checkAndReplaceIndex(index, params) {
  if (params.index) {
    return window.location.search.replace(`index=${params.index}`, `index=${index}`)
  }
  return window.location.search
}

function addIndex(index, params) {
  if (params.index) {
    return ''
  }
  return `${window.location.search === '' ? '?' : '&'}index=${index}`
}
